import React from 'react';
import { Paper,Divider, Grid } from '@material-ui/core';
import { FilterComponent } from '../../../shared_elements';
import Skeleton from '@material-ui/lab/Skeleton';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { transTypeGraphFilterOps } from '../'
import { jetStreamInstance } from '../../Leases';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
Highcharts.setOptions({
    lang: {
      numericSymbols: ["k", "M", "B", "T"],
      thousandsSep: ","
    }
  });
const CashflowTransTypeGraph = ({cashflowTransTypeGraph, skeletonLoader, filter, getResponseBack, callExternalFunction}) => {
    let filterOptions = Object.assign({}, transTypeGraphFilterOps);
    const options = {
        chart: {
            zoomType: 'xy',
            panning: true,
            panKey: 'shift'
        },
        title: {
            text: 'Based on Transaction Type',
            align: 'left',
            style: {
                fontFamily: 'Conv_IBMPlexSans-Regular',
                fontSize:'16px'
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b><br/>',
            valuePrefix: 'US$',
        },
        noData: {
            style: {
                fontWeight: 'bold',
                fontSize: '15px'
            }
        },
        subtitle: {
            text: `${cashflowTransTypeGraph.title ? cashflowTransTypeGraph.title : ''}`,
            align: 'left'
        },
        yAxis: {
            minRange: 1,
            title: {
                text: 'Amount(US$)'
            }
        },
        xAxis: {
            categories: cashflowTransTypeGraph && cashflowTransTypeGraph.cashflow_categories && cashflowTransTypeGraph.cashflow_categories.x_axis && cashflowTransTypeGraph.cashflow_categories.x_axis.categories
        },
        legend: {
            enabled: true
        },
        plotOptions:{
            series:{
                cursor: 'pointer',
                events: {
                    click: function (event) {
                        callExternalFunction(event.point.series.name, event.point.category, 'basedOnTransType');
                    }
                }
            }
        },
        series: cashflowTransTypeGraph && cashflowTransTypeGraph.reserve_cashflow,
        credits: false,
        exporting: {
            buttons: {
                contextButton: {
                  menuItems: ['downloadPNG', 'downloadPDF'],
                },
            }
         }
    }

    return (
        skeletonLoader ? <Skeleton variant="rect" height={440} width='100%' /> : 
        <Paper style={{height:jetStreamInstance?'478px':''}}>
            <div style={{padding:'0 5px'}}>
                <FilterComponent 
                    filter={filter}
                    filterMenu={filterOptions}
                    getResponseBack={(applyFilter) => getResponseBack(applyFilter)}
                />
            </div>
            <Divider />
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </div>
        </Paper>
    )
}
export default CashflowTransTypeGraph
